import HighLightPromotion from './HighLightPromotion.jsx';

export {
  HighLightPromotion
}


// WEBPACK FOOTER //
// ./components/fair/sub-view/promotion/index.js